<template>
  <ion-modal :is-open="isOpen" mode="md" @didDismiss="dismissModal" :backdropDismiss="true" :showBackdrop="true">
    <modals-layout :data="{ title: modalTitle }" @dismiss-modal="dismissModal">
      <div class="h-100 overflow-auto">
        <div class="character-card-small d-flex p-2 clickable" @click="selectPostAs(user.id, 'user', user)">
          <img v-image src="/images/user.jpg" />
          <div class="rest-info ml-3 flex-grow-1">
            <div class="name d-flex align-items-center justify-content-start">
              <div>
                {{ user.username }}
              </div>
            </div>
            <div class="description">
              <i>{{ yourselfText }}</i>
            </div>
          </div>
        </div>

        <div class="characters" v-if="userCharacters && userCharacters.length">
          <character-card-select-small
            v-for="character of userCharacters"
            :key="character.id"
            :character="character"
            class="my-3"
            @character-selected="selectPostAs(character.id, 'character', character)"
          />
          <p class="clickable" v-show="nextPageExists" @click="requestLoadMore">Load More</p>
        </div>
      </div>
    </modals-layout>
  </ion-modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { Action, Getter } from 'vuex-class';
import namespace from '@/store/namespace';
import { Character } from '@/types/static-types';
import CharacterCardSelectSmall from '@/shared-components/CharacterCardSelectSmall.vue';
import { authStore } from '~/pinia-store/auth';

@Options({
  name: 'PostAsSelectModal',
  components: { CharacterCardSelectSmall },
})
export default class PostAsSelectModal extends Vue {
  @Prop({ default: false }) isOpen!: boolean;
  @Prop({ default: 'Post As' }) modalTitle!: string;
  @Prop({ default: 'Post as yourself' }) yourselfText!: string;

  @Action('getUserCharacters', { namespace: namespace.CharactersModule })
  public getUserCharacters!: any;

  @Getter('userCharacters', { namespace: namespace.CharactersModule })
  public userCharacters!: Character[];
  
  @Getter('userCharactersPaging', { namespace: namespace.CharactersModule })
  public userCharactersPaging!: any;

  @Action('userCharactersNextPage', { namespace: namespace.CharactersModule })
  public userCharactersNextPage!: any;

  public get user() {
    const { user } = authStore();
    return user.value;
  }

  public dismissModal() {
    this.$emit('dismissModal');
  }

  public get nextPageExists() {
    return !!this.userCharactersPaging.next;
  }

  public async requestLoadMore(ev: CustomEvent) {
    if (!this.userCharactersPaging.next) {
      (ev?.target as any).complete();
    } else {
      await this.userCharactersNextPage();
    }
  }

  public selectPostAs(id: string, type: string, item: {}) {
    this.$emit('itemSelected', { id, type, item });
    this.dismissModal();
  }

  public mounted() {
    this.getUserCharacters(this.user)
  }
}
</script>

<style lang="sass" scoped>
.character-card-small
  img
    width: 60px
    height: 60px
    border-radius: 40px
    border: solid gray 0.1px
    object-fit: cover
  .name
    font-size: 18px
    font-weight: bold
  .description
    font-size: 13px
.clickable
  cursor: pointer
.clickable:hover
  opacity: 0.7
</style>

